// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// export const fetchPolicies = createAsyncThunk(
//   'policies/fetchPolicies',
//   async (userId) => {
//     const response = await fetch('https://fuellink-db-ui.azurewebsites.net/api/getAdminAllPolicies', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ userId })
//     });
//     const data = await response.json();
//     // console.log('Policies From Slice: ', data);
//     return data;
//   }
// );

// const policiesSlice = createSlice({
//   name: 'policies',
//   initialState: {
//     policies: [],
//     activePolicies: [],
//     status: 'idle',
//     error: null,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchPolicies.pending, (state) => {
//         state.status = 'loading';
//       })
//       .addCase(fetchPolicies.fulfilled, (state, action) => {
//         state.status = 'succeeded';
//         // Check if the response is an array
//         if (Array.isArray(action.payload)) {
//           state.policies = action.payload;        
//           state.activePolicies = action.payload.filter(policy => policy.Active);
//         } else {
//           // Handle non-array response (e.g., error message)
//           state.error = 'Received unexpected response format';
//         }
//       })
//       .addCase(fetchPolicies.rejected, (state, action) => {
//         state.status = 'failed';
//         state.error = action.error.message;
//       });
//   },
// });

// export default policiesSlice.reducer;

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const apiUrl= process.env.REACT_APP_API_URL;

export const fetchPolicies = createAsyncThunk(
  'policies/fetchPolicies',
  async (userId) => {
    const response = await fetch(`${apiUrl}/dataServer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'fetchPoliciesAndCardGroups',
        payload: { userId }
      })
    });
    const data = await response.json();
    // console.log('Policies From Slice: ', data);
    return data;
  }
);

// New thunk for paginated card groups with caching
export const fetchCardGroupsPaginated = createAsyncThunk(
  'policies/fetchCardGroupsPaginated',
  async (params, { getState }) => {
    const { userId, page = 1, pageSize = 50, sortField = 'cardGroupID', sortDirection = 'ASC', search = '', accountFilter = '', balanceFilter = '', forceRefresh = false } = params;

    const state = getState();
    const cacheKey = `${page}_${pageSize}_${sortField}_${sortDirection}_${search}_${accountFilter}_${balanceFilter}`;

    // Check if we have cached data and it's not stale (unless force refresh)
    if (!forceRefresh && state.policies.cardGroupsCache[cacheKey] && state.policies.cardGroupsCache[cacheKey].timestamp > Date.now() - 300000) { // 5 min cache
      return {
        ...state.policies.cardGroupsCache[cacheKey].data,
        fromCache: true
      };
    }

    const response = await fetch(`${apiUrl}/dataServer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'getCardGroupsAdmin',
        payload: {
          userId,
          page,
          pageSize,
          sortField,
          sortDirection,
          search,
          accountFilter,
          balanceFilter
        }
      })
    });

    if (!response.ok) {
      throw new Error('Failed to fetch card groups');
    }

    const data = await response.json();
    return {
      ...data,
      cacheKey,
      fromCache: false
    };
  }
);

const policiesSlice = createSlice({
  name: 'policies',
  initialState: {
    policies: [],
    cardGroups: [],
    activePolicies: [],

    // Paginated card groups state
    paginatedCardGroups: {
      data: [],
      pagination: null,
      sort: null,
      filters: null,
      loading: false,
      error: null,
      lastFetch: null
    },

    // Cache for different page/filter combinations
    cardGroupsCache: {},

    status: 'idle',
    error: null,
  },
  reducers: {
    clearCardGroupsCache: (state) => {
      state.cardGroupsCache = {};
    },
    invalidateCardGroupsCache: (state, action) => {
      // Invalidate specific cache key or all cache
      if (action.payload) {
        delete state.cardGroupsCache[action.payload];
      } else {
        state.cardGroupsCache = {};
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPolicies.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPolicies.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const { policies, cardGroups } = action.payload;

        // Set policies and card groups in the state
        state.policies = policies;
        state.cardGroups = cardGroups;

        // Filter active policies and include all card groups
        state.activePolicies = [
          ...policies.filter(policy => policy.Active)
        ];
      })
      .addCase(fetchPolicies.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })

      // Paginated card groups reducers
      .addCase(fetchCardGroupsPaginated.pending, (state) => {
        state.paginatedCardGroups.loading = true;
        state.paginatedCardGroups.error = null;
      })
      .addCase(fetchCardGroupsPaginated.fulfilled, (state, action) => {
        const { data, pagination, sort, filters, cacheKey, fromCache } = action.payload;

        state.paginatedCardGroups.loading = false;
        state.paginatedCardGroups.data = data;
        state.paginatedCardGroups.pagination = pagination;
        state.paginatedCardGroups.sort = sort;
        state.paginatedCardGroups.filters = filters;
        state.paginatedCardGroups.lastFetch = Date.now();

        // Cache the result if it's not from cache
        if (!fromCache && cacheKey) {
          state.cardGroupsCache[cacheKey] = {
            data: { data, pagination, sort, filters },
            timestamp: Date.now()
          };
        }
      })
      .addCase(fetchCardGroupsPaginated.rejected, (state, action) => {
        state.paginatedCardGroups.loading = false;
        state.paginatedCardGroups.error = action.error.message;
      });
  },
});

export const { clearCardGroupsCache, invalidateCardGroupsCache } = policiesSlice.actions;
export default policiesSlice.reducer;

